import React from 'react';
import PropTypes from 'prop-types';
import Sign from '../Icons/Sign';

const MinusSign = ({ onClick, style, tabIndex, }) => (
    <button
        className="minus-sign"
        onClick={onClick}
        tabIndex={tabIndex}
        style={style}
    >
        <Sign glyph="MINUS_CIRCLE"/>
    </button>
);

MinusSign.propTypes = {
    onClick: PropTypes.func,
    tabIndex: PropTypes.number,
    style: PropTypes.shape({
        transform: PropTypes.string,
    }),
};

MinusSign.defaultProps = {
    onClick: () => {},
    tabIndex: 0,
    style: {},
};

export default MinusSign;